import axios from "axios";

const Server = {
  getAccountConfig: async (params, baseURL, keys) => {
    return await axios.get(baseURL + "configuration/" + params.application, {
      headers: {
        clientCode: keys.clientCode,
        sessionKey: keys.sessionKey,
        "Look-Deeper": true,
      },
      withCredentials: true,
    });
  },

  getUserRights: async (baseURL, keys) => {
    return await axios.get(`${baseURL}v1/user/rights`, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },

  updateAccountConfig: async (values, baseURL, keys) => {
    return await axios.put(baseURL + "configuration", values, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },

  saveAccountConfig: async (values, baseURL, keys) => {
    return await axios.post(baseURL + "configuration", values, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },

  deleteAccountConfig: async (id, baseURL, keys) => {
    return await axios.delete(baseURL + "v3/configuration/" + id, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },

  getAccounts: async (baseURL, keys) => {
    return await axios.get(`${baseURL}configuration/apps`, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },

  getRegisters: async (baseURL, keys) => {
    return await axios.get(`${baseURL}v1/pointofsale`, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },

  getLoginSettingsConfig: async (baseURL, keys) => {
    return await axios.get(`${baseURL}v1/configuration`, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },

  saveLoginSettingsConfig: async (values, baseURL, keys) => {
    return await axios.patch(`${baseURL}v1/configuration`, values, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },
};

export default Server;
